import {
  HTTPValidationError,
  createQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsPost,
  CreateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsPostResponse,
  CreateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsPostData,
} from '@common/config/api/client'
import { queryClient } from '@common/config/api/queryClient'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export const useCreateQcStudyDefinitionMutation = (): UseMutationResult<
  CreateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsPostResponse,
  AxiosError<HTTPValidationError>,
  CreateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsPostData
> => {
  return useMutation<
    CreateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsPostResponse,
    AxiosError<HTTPValidationError>,
    CreateQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsPostData
  >({
    mutationFn: async (query) => {
      const response = await createQcStudyDefinitionQcTasksQcTaskIdSubmissionsQcTaskSubmissionIdStudyDefinitionsPost({
        path: query.path,
        body: query.body,
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['QCTask'] })
    },
  })
}
